module.exports = __webpack_public_path__ + "static/symbiosis_board_medium.cda04496.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/boards/symbiosis_board_medium.jpg
// module id = 633
// module chunks = 123502253449456